import { Children, cloneElement } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableRow = _ref => {
  let {
    children,
    _isTableHeadChild,
    ...tableRowProps
  } = _ref;
  const renderChildren = () => {
    return Children.map(children, child => {
      // Extend props before rendering.
      if (child && child.props) {
        return /*#__PURE__*/cloneElement(child, {
          _isTableHeadChild: _isTableHeadChild
        });
      }
      return child;
    });
  };
  return /*#__PURE__*/_jsx("tr", {
    role: "row",
    ...tableRowProps,
    children: _isTableHeadChild ? renderChildren() : children
  });
};
export default TableRow;